import AccountChild from 'mdi-material-ui/AccountChild';
import HeartCircle from 'mdi-material-ui/HeartCircle';
import MultiplicationBox from 'mdi-material-ui/MultiplicationBox';
import PineTree from 'mdi-material-ui/PineTree';
import Halloween from 'mdi-material-ui/Halloween';
import Turkey from 'mdi-material-ui/Turkey';
import EggEaster from 'mdi-material-ui/EggEaster';
import PalmTree from 'mdi-material-ui/PalmTree';

import Pets from '@mui/icons-material/Pets';
import Brush from '@mui/icons-material/Brush';
import EmojiEvents from '@mui/icons-material/EmojiEvents';
import Cake from '@mui/icons-material/Cake';
import Flare from '@mui/icons-material/Flare';
import DirectionsBus from '@mui/icons-material/DirectionsBus';
import People from '@mui/icons-material/People';
import Fastfood from '@mui/icons-material/Fastfood';
import SportsEsports from '@mui/icons-material/SportsEsports';
import InsertEmoticon from '@mui/icons-material/InsertEmoticon';
import FlightTakeoff from '@mui/icons-material/FlightTakeoff';
import LocalMovies from '@mui/icons-material/LocalMovies';
import MusicNote from '@mui/icons-material/MusicNote';
import Loyalty from '@mui/icons-material/Loyalty';
import School from '@mui/icons-material/School';
import Event from '@mui/icons-material/Event';
import Sports from '@mui/icons-material/Sports';
import Accessibility from '@mui/icons-material/Accessibility';
import ChildCare from '@mui/icons-material/ChildCare';
import House from '@mui/icons-material/House';
import LocalFlorist from '@mui/icons-material/LocalFlorist';
import GolfCourse from '@mui/icons-material/GolfCourse';

export const iconPack = {
	animals: Pets,
	arts: Brush,
	awards: EmojiEvents,
	birthdays: Cake,
	faith: Flare,
	family: AccountChild,
	field_trips: DirectionsBus,
	friends: People,
	food: Fastfood,
	games: SportsEsports,
	interests: InsertEmoticon,
	travel: FlightTakeoff,
	vacation: PalmTree,
	movies: LocalMovies,
	music: MusicNote,
	other: HeartCircle,
	personal: Loyalty,
	school: School,
	special_events: Event,
	sports: Sports,
	relatives: Accessibility,
	siblings: ChildCare,
	current_home: House,
	holidays: MultiplicationBox,
	mothers_day: LocalFlorist,
	fathers_day: GolfCourse,
	christmas: PineTree,
	halloween: Halloween,
	thanksgiving: Turkey,
	easter: EggEaster,
};
